import { format } from 'date-fns'
import IconToken from '@/components/icons/IconToken'
import numberFormat from '@/utils/numberFormat'

function shortenTxId(s) {
  return `${s.substring(0, 5)}...${s.substring(s.length - 5)}`
}

export default function AssetHistoryRow({
  accountId,
  blockExplorerUrl,
  history
}) {
  const { token, amount, tx_id, trans_status, created_time } = history
  return (
    <tr className="table-list-row">
      <td className="table-list-cell align-left">
        <div className="token-label">
          <IconToken symbol={token} />
          {token}
        </div>
      </td>
      <td className="table-list-cell align-left">
        {numberFormat(amount, 'max8')}
      </td>
      <td className="table-list-cell align-left">
        <a
          className="block-explorer-link"
          target="_blank"
          href={`${blockExplorerUrl}/accounts/${accountId}`}
          rel="noreferrer"
        >
          {accountId}
        </a>
      </td>
      <td className="table-list-cell align-left">
        <a
          className="block-explorer-link"
          target="_blank"
          href={`${blockExplorerUrl}/transactions/${tx_id}`}
          rel="noreferrer"
        >
          {shortenTxId(tx_id)}
        </a>
      </td>
      <td className="table-list-cell align-center capitalize">
        {trans_status.toLowerCase()}
      </td>
      <td className="table-list-cell align-right">
        {format(created_time, 'yyyy-MM-dd HH:mm:ss')}
      </td>
    </tr>
  )
}
